/**
 * Chat service
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('ItxChatSvc', ItxChatSvc);

    ItxChatSvc.$inject = ['CmsConfigSvc', 'CommonServices', '$q', 'ItxScreenSizeSvc', 'DUTTI_CONS'];

    function ItxChatSvc(CmsConfigSvc, CommonServices, $q, ItxScreenSizeSvc, DUTTI_CONS) {
        var service = {
            initHubtypeUrlChats: _initHubtypeUrlChats,
            initStyleAdvisor: _initStyleAdvisor,
            openStyleAdvisor: _openStyleAdvisor,
            openHubtype: _openHubtype,
            closeHubtype: _closeHubtype,
            openKakaoChat: _openKakaoChat,
            closeKakaoChat: _closeKakaoChat,
            openUrlChat: _openUrlChat,
            checkIfStyleAdvisorIsActive: _checkIfStyleAdvisorIsActive
        };

        return service;

        /**
         * Función para inicializar los chats de Hubtype y UrlChat
         */
        function _initHubtypeUrlChats() {
            var deferred = $q.defer();

            // Configuración para Hubtype
            const hubtype = CmsConfigSvc.getProperty('chatbot_hubtype');

            // Configuración para Url Chat
            const urlChat = CmsConfigSvc.getProperty('chatbot_url');

            // Configuracion para Kakao Talk
            const kakao = CmsConfigSvc.getProperty('kakao_talk');
            

            $q.all({ hubtype: hubtype, urlChat: urlChat, kakao: kakao }).then(function (response) {
                // Comprueba si Hubtype debe mostrarse en base a su configuración
                if (response.hubtype && response.hubtype.active) {
                    response.hubtype = checkIfHubtypeIsActive(response.hubtype);
                }

                // Comprueba si kakao debe mostrarse en base a su configuración
                if (response.kakao && response.kakao.active) {
                    response.kakao = response.kakao;
                }else{
                    response.kakao = false;
                }

                deferred.resolve(response);
            });

            return deferred.promise;
        }

        /**
         * Función para inicializar Style Advisor
         */
        function _initStyleAdvisor() {
            var deferred = $q.defer();

            // Obtenemos la configuración
            CmsConfigSvc.getProperty('chatbot_style_advisor').then(function (config) {
                // Comprobamos si debe estar activo
                var secondDeferred = $q.defer();

                _checkIfStyleAdvisorIsActive(config).then(function (config) {
                    secondDeferred.resolve(config);
                });

                deferred.resolve(secondDeferred.promise);
            });

            return deferred.promise;
        }

        /**
         * Función para mostrar el Style Advisor
         */
        function _openStyleAdvisor() {
            $('#hero-iframe-container').addClass('open');
            $('#hero-iframe-container div.hero-launcher-container.active').addClass('show');

            hero('show');

            // Añadimos en local storge un control para saber que estamos con una conversación abierta (solo para Desktop)
            if (ItxScreenSizeSvc.is('md,lg')) {
                inditex.setLocalStorage('openStyleAdvisorInUse', true);
            }
        }

        /**
         * Función para mostrar Hubtype
         */
        function _openHubtype() {
            if (inditex.micrositeLegacy) {
                const options = {
                    bubbles: true,
                    composed: true
                };
                document.dispatchEvent(new CustomEvent('legacy-event-chat', options));
            } else if (inditex.hybridPage) {
                if (window.Botonic) {
                    window.Botonic.open();
                    $('#chatbot-botonic').show();
                    // Añadimos en local storge un control para saber que estamos con una conversación abierta (Solo Desktop)
                    if (!CommonServices.isWebapp()) {
                        inditex.setLocalStorage('hubtypeInUse', true);
                    }
                }
            }
        }

        /**
         * Función para mostrar Kakao
         */
        function _openKakaoChat() {
            $('#kakao-chat').addClass('open');
        }

        /**
         * Función para cerrar Kakao
         */
        function _closeKakaoChat() {
            $('#kakao-chat').removeClass('open');
        }
        
        /**
         * Función para cerrar Hubtype
         */
        function _closeHubtype() {
            if (window.Botonic) {
                window.Botonic.close();
                $('#chatbot-botonic').hide();

                // Quitamos el control de uso
                inditex.removeLocalStorage('hubtypeInUse');
            }
        }

        /**
         * Función para mostrar Url Chat
         */
        function _openUrlChat() {
            $('.url-chat').addClass('open');
        }

        /**
         * Función para comprobar si Style Advisor debe estar activo en base a su configuración (Solo para Desktop)
         */
        function _checkIfStyleAdvisorIsActive(config) {
            var deferred = $q.defer();

            // Obtenemos la configuración de activación por segmentos
            CmsConfigSvc.getProperty('style_advisor_access').then(function (status) {
                // En función del estado lo mustramos a un segmento u otro
                switch (status.trim()) {
                    // No mostramos a  ningún usuario
                    case 'NO':
                        config.active = false;
                        break;
                    // Mostramos solo a los usuario autenticados que sean feel
                    case 'FEEL':
                        if (CommonServices.is360()) {
                            config = checkStyleAdvisorCookies(config);
                        } else {
                            config.active = false;
                        }
                        break;
                    // Mostramos a todos los usuarios
                    case 'ALL':
                        config = checkStyleAdvisorCookies(config);
                        break;
                    // Mostramos a los usuarios que tengan la opción activa en su cuenta
                    case 'EARLY':
                        if (CommonServices.is360() && inditex.iUserJSON.isStyleAdvisor) {
                            config = checkStyleAdvisorCookies(config);
                        } else {
                            config.active = false;
                        }
                        break;
                }

                deferred.resolve(config);
            });

            return deferred.promise;
        }

        /**
         * Función para comprobar si las cookies de Style Advisor estar activas
         */
        function checkStyleAdvisorCookies(config) {
            if (
                !CommonServices.isWebapp() &&
                CommonServices.isCookieGroupAllowed(DUTTI_CONS.COOKIE_GROUPS.ANALYTICS)
            ) {
                config.active = true;
            } else if (
                !CommonServices.isWebapp() &&
                !CommonServices.isCookieGroupAllowed(DUTTI_CONS.COOKIE_GROUPS.ANALYTICS)
            ) {
                config.active = false;
            } else if (CommonServices.isWebapp()) {
                config.active = true;
            }

            return config;
        }

        /**
         * Función para comprobar si Hubtype debe estar activo en base a su configuración
         */
        function checkIfHubtypeIsActive(config) {
            // Solo realizamos las comprobaciones para Desktop
            if (!CommonServices.isWebapp()) {
                // Establecemos como inactivo por defecto
                config.active = false;

                // Comprueba si debe estar activo en la página actual
                var enabledInPage = false;

                enabledInPage = _.find(config.sections, function (section) {
                    if (section === inditex.iPage) {
                        return true;
                    }
                });

                // Comprueba si debe estar activo en base a si el usuario está autenticado
                var enabledByLogin = true;

                if (config.loginRequired) {
                    enabledByLogin = this.ItxLoginSvc.isLogged();
                }

                // Comprueba si debe estar activo en el idioma actual
                var isSupportedLanguage = false;

                if (config.languages.indexOf(inditex.iLangId.toString()) !== -1) {
                    isSupportedLanguage = true;
                }

                if (enabledInPage && enabledByLogin && isSupportedLanguage) {
                    config.active = true;
                }
            }

            return config;
        }
    }
})(window.itxApp);
